import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getCustomFormsByIds } from '../../../../api/CustomForms';

export const useCustomFormsById = ({ dependencies = [], params = {}, options }) => {
  const navigate = useNavigate();
  return useQuery(
    ['customFormsById', ...dependencies],
    () => getCustomFormsByIds(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...options
    }
  );
};
